import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import SearchIcon from "@mui/icons-material/Search"
import Modal from "react-modal"
import CloseIcon from "@mui/icons-material/Close"
import { useGlobalContext } from "../../../Context/GlobalContext"
import Select from "react-select"
import { saveAs } from "file-saver"
import jsPDF from "jspdf"
import DeleteIcon from "@mui/icons-material/Delete"
import { IoMdArrowDropright } from "react-icons/io"
import ConfirmationModal from "../../../components/Staff/Modals/ConfirmationModal"
import SearchStaff from "../../../components/Staff/SearchStaff"
import BorderColorIcon from "@mui/icons-material/BorderColor"
import Cookies from "js-cookie"
import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

const TableRowSkeleton = () => (
  <tr className="border-gray-300 border-b">
    {[...Array(8)].map((_, index) => (
      <td key={index} className="border-[#dbdbdb] p-2 border-r text-center">
        <Skeleton width={index === 0 ? 30 : 80} />
      </td>
    ))}
  </tr>
)

const TableHeaderSkeleton = () => (
  <tr>
    {[...Array(8)].map((_, index) => (
      <th key={index} className="p-3 border-r font-medium text-[13px] text-center whitespace-nowrap">
        <Skeleton width={index === 0 ? 30 : 80} />
      </th>
    ))}
  </tr>
)

const PaginationSkeleton = () => (
  <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md">
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={60} />
    </div>
    <div className="pt-2 pb-[8px] px-3">
      <Skeleton width={20} />
    </div>
    <div className="pt-2 pb-[8px] px-2">
      <Skeleton width={40} />
    </div>
  </div>
)

const ProjectPriority = () => {
  const [open11, setOpen11] = useState(false)

  const onOpenModal11 = () => setOpen11(true)
  const onCloseModal11 = () => setOpen11(false)
  const { baseUrl, openToast } = useGlobalContext()
  const [openIndex, setOpenIndex] = useState(null)
  const [selectedPriority, setSelectedPriority] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  // Function to handle accordion toggling
  const handleToggle = (index) => {
    if (openIndex === index) {
      setOpenIndex(null) // Close the accordion if clicked again
    } else {
      setOpenIndex(index) // Open the accordion
    }
  }
  //salary dropdown
  const [isOpen1, setIsOpen1] = useState(false)

  const toggleDropdown1 = () => {
    setIsOpen1(!isOpen1)
  }

  //salary dropdown

  //Toggle swich off on btn
  const [isOn, setIsOn] = useState(false)

  const toggleSwitch = () => {
    setIsOn(!isOn)
  }

  //Toggle swich off on btn

  //Modal
  // State to control the visibility of the modal
  const [isOpen, setIsOpen] = useState(false)

  // Function to toggle the modal
  const toggleModal = () => {
    setIsOpen(!isOpen)
  }

  //Modal2
  //Modal
  // State to control the visibility of the modal
  const [isOpen3, setIsOpen3] = useState(false)

  // Function to toggle the modal
  const toggleModal3 = () => {
    setIsOpen3(!isOpen3)
  }

  //Modal2

  const [isOpen5, setIsOpen5] = useState(true)

  // Toggle the visibility of tbody
  const toggleTable = () => {
    setIsOpen5(!isOpen5)
  }

  let subtitle

  const [modalIsOpen6, setIsOpen6] = React.useState(false)
  function openModal6() {
    setIsOpen6(true)
  }
  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000"
  }

  function closeModal6() {
    setIsOpen6(false)
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      backgroundColor: "#F4F5F9",
      borderColor: "#E2E8F0",
      minHeight: "38px",
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#E2E8F0",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      fontSize: "14px",
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#4A5568",
      ":hover": {
        backgroundColor: "#CBD5E0",
        color: "#2D3748",
      },
    }),
  }

  const [prorityName, setPriorityName] = useState()
  const [priorityColor, setPriorityColor] = useState()
  const [priorityOrder, setPriorityOrder] = useState()
  const [filter, setFilter] = useState(false)
  const [canChanged, setCanChanged] = useState([])
  const [selectStaffId, setSelectStaffId] = useState([])
  const [staffId, setStaffId] = useState([])
  const [canChangedId, setCanChangedId] = useState([])

  useEffect(() => {
    if (selectedPriority) {
      setStaffId(selectedPriority.is_hidden.map((item) => item.id))
      setCanChangedId(selectedPriority.can_changed.map((item) => item.id))
    }
  }, [selectedPriority])

  async function submitProjectPriority() {
    setIsLoading(true)

    try {
      const result = await fetch(baseUrl + "project-Priority", {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          Priority_name: prorityName,
          Priority_color: priorityColor || "black",
          Priority_order: Number(priorityOrder),
          default_filter: filter,
          is_hidden: selectStaffId,
          can_changed: canChanged,
        }),
      })
      // console.log(result);
      const response = await result.json()
      if (result.status == 201) {
        setIsOpen(false)
        openToast("Project priority added successfully", "success")
        setIsLoading(false)
        fetchProjectPriority()
        setPriorityName("")
        setPriorityColor("")
        setPriorityOrder("")
        setFilter(false)
        setSelectStaffId([])
        setCanChanged([])
      } else {
        openToast(response.message || "An unexpected error occcured", "error")
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        console.error("Network error or server unavailable:", error)
        openToast("Unable to connect to the server. Please check your network or try again later.", "error")
      } else {
        console.error("Unexpected error:", error)
        openToast("An unexpected error occurred. Please try again.", "error")
      }
    } finally {
      setIsLoading(false)
    }
  }

  async function updatePriority() {
    setIsLoading(true)
    try {
      const response = await fetch(baseUrl + "project-Priority/" + selectedPriority.id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify({
          Priority_name: selectedPriority.Priority_name,
          Priority_color: selectedPriority.Priority_color,
          Priority_order: selectedPriority.Priority_order,
          default_filter: selectedPriority.default_filter,
          is_hidden: staffId,
          can_changed: canChangedId,
        }),
      })

      const data = await response.json()
      if (response.status === 200) {
        setIsLoading(false)
        openToast(data.message, "success")
        setIsOpen6(false)
        fetchProjectPriority()
        setSelectedPriority(null)
      } else {
        openToast(data.message, "error")
      }
    } catch (error) {
      openToast(error.message, "error")
    } finally {
      setIsLoading(false)
    }
  }

  async function deleteProjectPriority(id) {
    try {
      setIsLoading(true)
      const response = await fetch(baseUrl + "project-Priority/" + id, {
        method: "DELETE",
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      })
      const data = await response.json()
      if (response.status === 200) {
        openToast("Project priority deleted successfully", "success")
        fetchProjectPriority()
        setOpen11(false)
      } else {
        openToast(data.message, "error")
      }
    } catch (error) {
      openToast(error.message, "error")
    } finally {
      setIsLoading(false)
    }
  }

  const [projectPriorityDetail, setProjectPriorityDetail] = useState()
  async function fetchProjectPriority() {
    try {
      setIsLoading(true)
      const result = await fetch(baseUrl + "project-Priority", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      })
      const data = await result.json()
      if (result.status === 200) {
        setProjectPriorityDetail(data?.data)
      } else {
        openToast("Unable to fetch project project priority", "error")
      }
    } catch (error) {
      openToast("Error fetching project project priority", "error")
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchProjectPriority()
  }, []) //Fixed useEffect dependency

  const [exportFormat, setExportFormat] = useState("")
  const handleExport = () => {
    if (exportFormat === "CSV") exportCSV()
    else if (exportFormat === "PDF") exportPDF()
    else if (exportFormat === "Print") printDepartments()
  }

  const exportCSV = () => {
    const csvData = projectPriorityDetail
      .map((dep) => `${dep.Priority_name}, ${dep.Priority_color}, ${dep.Priority_order}`)
      .join("\n")
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" })
    saveAs(blob, "ProjectStatus.csv")
  }

  const exportPDF = () => {
    const doc = new jsPDF()
    doc.text("AllTaskStatus", 20, 10)
    projectPriorityDetail.forEach((dep, index) => {
      doc.text(`${index + 1}. ${dep.Priority_name},${dep.project_color},${dep.Priority_order}`, 10, 20 + index * 10)
    })
    doc.save("ProjectStatus.pdf")
  }

  const printDepartments = () => {
    const printContent = projectPriorityDetail
      .map((dep) => `${dep.Priority_name},${dep.Priority_color}, ${dep.Priority_order} (Total Users: 1)`)
      .join("\n")
    const newWindow = window.open()
    newWindow.document.write(`<pre>${printContent}</pre>`)
    newWindow.document.close()
    newWindow.print()
  }
  const [rowsToShow, setRowsToShow] = useState(25)
  const handleSelectChange = (event) => {
    setRowsToShow(Number(event.target.value))
  }
  const [open8, setOpen8] = useState(false)

  const onOpenModal8 = () => setOpen8(true)
  const onCloseModal8 = () => setOpen8(false)

  // console.log(selectStaffId);

  return (
    <div className="w-full">
      <div className="bg-[#fff] p-[10px]">
        <div className="set-shadow p-[20px] rounded-md w-full">
          <div className="flex items-center gap-[14px] mb-[10px]">
            <div className="flex justify-center items-center h-[50px] text-[14px]">
              {/* Button to open the modal */}
              <button onClick={toggleModal} className="second-btn">
                Add Project Priority
              </button>

              {/* Modal (visible only when isOpen is true) */}
              {isOpen && (
                <div className="z-[999] fixed inset-0 flex justify-center items-center bg-gray-800 bg-opacity-50">
                  <div className="bg-white shadow-lg rounded-lg w-96">
                    {/* Modal Header */}
                    <div className="px-4 py-2 border-b">
                      <h2 className="font-semibold text-lg">Create New Project Priority</h2>
                    </div>

                    {/* Modal Body */}
                    <div className="p-4">
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Priority Name</label>
                        <br />
                        <input
                          type="text"
                          onChange={(e) => {
                            setPriorityName(e.target.value)
                          }}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Priority Color</label>
                        <br />
                        <input
                          type="color"
                          placeholder=""
                          onChange={(e) => {
                            setPriorityColor(e.target.value)
                          }}
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="mb-[10px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">*Priority Order</label>
                        <br />
                        <input
                          type="text"
                          onChange={(e) => {
                            setPriorityOrder(e.target.value)
                          }}
                          placeholder=""
                          className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none newsetup3"
                        />
                      </div>
                      <div className="flex items-center gap-[6px] mb-[10px]">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            setFilter(e.target.value)
                          }}
                        />
                        <p>Default Filter</p>
                      </div>
                      <div className="mb-[26px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">is hidden for</label>
                        <br />
                        <SearchStaff
                          setMembers={setSelectStaffId}
                          members={selectStaffId}
                          title="Select Staff"
                          noTitle={true}
                        />
                      </div>
                      <div className="mb-[20px] w-[100%] xl:[48%]">
                        <label className="text-[14px]">Can be changed to</label>
                        <br />
                        <Select
                          isMulti
                          placeholder="Can be changed to"
                          options={
                            projectPriorityDetail
                              ? projectPriorityDetail?.map((item, index) => {
                                  return {
                                    value: item.id,
                                    label: item.Priority_name,
                                  }
                                })
                              : []
                          }
                          onChange={(e) => setCanChanged(e.map((item) => item?.value))}
                          className="w-full h-[40px] newsetup3"
                          required
                        />
                      </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="flex justify-end px-4 py-2 border-t">
                      <button onClick={toggleModal} className="mr-2 first-btn">
                        Close
                      </button>
                      <button
                        onClick={submitProjectPriority}
                        disabled={isLoading}
                        className={` ${isLoading ? "second-btn-disabled" : "second-btn"}`}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="flex md:flex-row lg:flex-row xl:flex-row flex-col justify-between items-start gap-[10px] mb-[14px]">
            <div className="flex items-center gap-[10px]">
              <div className="inline-block relative text-left">
                {/* Button to open/close the dropdown */}
                <select
                  onChange={handleSelectChange}
                  className="border-[#e5e7eb] shadow-sm mr-2 p-[7px] pr-3 border rounded-md text-[14px] focus:outline-none"
                >
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="120">120</option>
                </select>

                {/* Dropdown menu */}
                {isOpen1 && (
                  <div className="right-0 left-[0px] z-10 absolute border-gray-200 bg-white shadow-lg mt-2 border rounded-md w-[100%] origin-top-right">
                    <div className="" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        30
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        40
                      </a>
                      <a
                        href="#"
                        className="block hover:bg-gray-100 p-[5px] text-center text-gray-700 text-sm"
                        role="menuitem"
                      >
                        50
                      </a>
                    </div>
                  </div>
                )}
              </div>

              <select
                onChange={(e) => setExportFormat(e.target.value)}
                className="border-[#e5e7eb] shadow-sm p-[7px] border rounded-md text-[14px] text-sm focus:outline-none"
              >
                <option value="CSV">CSV</option>
                <option value="PDF">PDF</option>
                <option value="Print">Print</option>
              </select>
              <button onClick={handleExport} className="second-btn">
                Export
              </button>
            </div>
            <div className="relative w-full md:w-[200px] lg:w-[200px] xl:w-[200px]">
              <input
                className="p-[6px] pr-[25px] summary-border rounded-2xl w-full text-[13px]"
                type="text"
                placeholder=" Search......."
              />
              <SearchIcon className="top-[8px] right-[8px] absolute newadd2" />
            </div>
          </div>
          <div className="border-[#dcdbdb] bg-white shadow-cs border rounded-lg w-full overflow-x-auto">
            <table className="rounded-md w-full table-auto table-status">
              <thead onClick={toggleTable} className="set-shadow cursor-pointer">
                {isLoading ? (
                  <TableHeaderSkeleton />
                ) : (
                  <tr>
                    <th className="flex justify-center items-center p-3 border-r font-medium text-center text-xs whitespace-nowrap">
                      <IoMdArrowDropright
                        className={`text-[20px] transition-transform duration-200 ${
                          isOpen5 ? "rotate-90 text-[black]" : "rotate-0"
                        }`}
                      />
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">ID</th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">Project Name</th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">Project Color</th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">Project Order</th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap"> Default Filter</th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">
                      Project can be changed to
                    </th>
                    <th className="border-[#dbdbdb] p-3 border-r text-center whitespace-nowrap">Action</th>
                  </tr>
                )}
              </thead>
              {/* Add transition for tbody */}

              <tbody
                className={`transition-all duration-500 ease-in-out overflow-hidden ${isOpen5 ? "max-h-screen" : "max-h-0"}`}
                style={{ display: isOpen5 ? "table-row-group" : "none" }}
              >
                {isLoading ? (
                  [...Array(10)].map((_, index) => <TableRowSkeleton key={index} />)
                ) : projectPriorityDetail && projectPriorityDetail?.length > 0 ? (
                  projectPriorityDetail?.map((s, index) => {
                    return (
                      <tr key={s.id} className="border">
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">#</td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">{index + 1}</td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">{s.Priority_name}</td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">{s.Priority_color}</td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">{s.Priority_order}</td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                          {s.default_filter ? "Yes" : "No"}
                        </td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                          {s.is_hidden.map((item) => item.User.name).join(", ")}
                        </td>
                        <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                          <div className="flex justify-center items-center gap-3">
                            <button
                              className="rounded-md text-white"
                              onClick={() => {
                                setSelectedPriority(s)
                                openModal6()
                              }}
                            >
                              <BorderColorIcon className="text-[#27004a] text-xl" />
                            </button>
                            <div>
                              <button
                                onClick={() => {
                                  setOpen11(true)
                                }}
                              >
                                <DeleteIcon className="text-red-500 cursor-pointer" />
                              </button>
                              {open11 && (
                                <ConfirmationModal
                                  setClose={onCloseModal11}
                                  callback={deleteProjectPriority}
                                  id={s.id}
                                />
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr className="h-[100px]">
                    <td colSpan="8" className="py-4 font-semibold text-center text-red-500 text-sm">
                      Project Priority Not Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {isLoading ? (
            <PaginationSkeleton />
          ) : (
            <div className="flex sm:flex-row flex-col justify-between items-center gap-2 sm:gap-0 p-3 pt-5 w-[100%]">
              <p className="text-[#a5a1a1] text-[14px]">
                Showing 1 to {rowsToShow} of {projectPriorityDetail?.length} entries
              </p>
              <div className="flex gap-2 pt-0 pr-4 pb-0 pl-4 border rounded-md pagination">
                <Link to="#" className="pt-2 pb-[8px] text-[12px]">
                  Previous
                </Link>
                <span className="flex items-center bg-[#27004a] pr-3 pl-3 text-[12px] text-white">1</span>
                <Link to="#" className="pt-2 pb-[8px] text-[12px]">
                  Next
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        isOpen={modalIsOpen6}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal6}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] z-[50px] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2 ref={(_subtitle) => (subtitle = _subtitle)} className="border-[#000] p-3 border-b text-[14px]">
          Edit New Task
        </h2>
        <button
          onClick={closeModal6}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>

        <div className="first-panel">
          <div className="p-4">
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Name</label>
              <br />
              <input
                type="text"
                placeholder=""
                value={selectedPriority?.Priority_name}
                onChange={(e) =>
                  setSelectedPriority({
                    ...selectedPriority,
                    Priority_name: e.target.value,
                  })
                }
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:newsetup3 focus:outline-none"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Color</label>
              <br />
              <input
                type="color"
                placeholder=""
                value={selectedPriority?.Priority_color}
                onChange={(e) => {
                  setSelectedPriority({
                    ...selectedPriority,
                    Priority_color: e.target.value,
                  })
                }}
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
              />
            </div>
            <div className="mb-[10px] w-[100%] xl:[48%]">
              <label className="text-[14px]">*Status Order</label>
              <br />
              <input
                type="text"
                placeholder=""
                value={selectedPriority?.Priority_order}
                onChange={(e) =>
                  setSelectedPriority({
                    ...selectedPriority,
                    Priority_order: e.target.value,
                  })
                }
                className="border-1 bg-[#fff] mt-1 p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none"
              />
            </div>
            <div className="flex items-center gap-[6px] mb-[10px]">
              <input
                type="checkbox"
                checked={selectedPriority?.default_filter}
                onChange={(e) =>
                  setSelectedPriority({
                    ...selectedPriority,
                    default_filter: e.target.checked,
                  })
                }
              />
              <p>Default Filter</p>
            </div>
            <div className="mb-[26px] w-[100%] xl:[48%]">
              <label className="text-[14px]">is hidden for</label>
              <br />
              <SearchStaff
                members={staffId}
                noTitle={true}
                setMembers={setStaffId}
                names={selectedPriority?.is_hidden.map((staff) => ({
                  name: staff?.User?.name,
                  staffDetails: { id: staff?.id },
                }))}
              />
            </div>
            <div className="mb-[20px] w-[100%] xl:[48%]">
              <label className="text-[14px]">Can be changed to</label>
              <br />
              <Select
                isMulti
                placeholder="Can be changed to"
                defaultValue={selectedPriority?.can_changed.map((item) => ({
                  value: item.id,
                  label: item.Priority_name,
                }))}
                options={
                  projectPriorityDetail
                    ? projectPriorityDetail?.map((item, index) => {
                        return {
                          value: item.id,
                          label: item.Priority_name,
                        }
                      })
                    : []
                }
                onChange={(e) => setCanChangedId(e.map((item) => item.value))}
                className="w-full h-[40px]"
                required
              />
            </div>
          </div>

          <div className="flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t">
            <button className="first-btn" onClick={closeModal6}>
              Cancel
            </button>
            <button
              disabled={isLoading}
              onClick={updatePriority}
              className={` ${isLoading ? "second-btn-disabled" : "second-btn"}`}
            >
              update
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ProjectPriority

